import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import {WebviewUtils} from '@shared/webviewUtils';

function LicenseRenewalFailPoliceCaseBottomSheet() {
  const {t} = useInferableTranslation();
  return (
    <div className="bottom_sheet">
      <div className="bottom_sheet_header">
        <h2 className="bottom_sheet_title">{t('T10226')}</h2>
        <button
          type="button"
          className="btn btn_ic"
          aria-label={t('T10017')}
          onClick={() => window.bottomSheetClose()}
        >
          <span
            className="ic ic_close_20px"
            aria-hidden="true"
          />
        </button>
      </div>
      <div className="bottom_sheet_inner">
        <div className="bottom_sheet_contents">
          <strong className="bottom_sheet_title_sub">{t('T10299_$link', {link: import.meta.env.VITE_LICENSE_RENEWAL_URL})}</strong>
          <div className="bottom_sheet_box">
            <div className="divider" />
            <p className="bottom_sheet_text">{t('T10300')}</p>
            <p className="bottom_sheet_text">{t('T10301')}</p>
            <p className="bottom_sheet_text">{t('T10302')}</p>
            <p className="bottom_sheet_text">{t('T10303')}</p>
            <p className="bottom_sheet_text">{t('T10304')}</p>
            <p className="bottom_sheet_text">{t('T10305')}</p>
          </div>
        </div>
        <div className="bottom_sheet_footer bottom_sheet_footer_complex">
          <button
            type="button"
            className="btn btn_large btn_outline"
            onClick={() => window.bottomSheetClose()}
          >
            {t('T10221')}
          </button>
          <button
            type="button"
            className="btn btn_large btn_filled"
            onClick={() => WebviewUtils.openWebBrowser(import.meta.env.VITE_LICENSE_RENEWAL_URL)}
          >
            {t('T10232')}
          </button>
        </div>
      </div>
    </div>
  );
}

export default LicenseRenewalFailPoliceCaseBottomSheet;
